import { useState } from 'react';
import type { ReactNode } from 'react';

import { Button, ButtonGroup, MenuItem, type ButtonGroupProps } from '@mui/material';

import { ChevronDownIcon } from '@shared/ui/icons';

import { Menu } from '../menu';

export type SplitButtonOption = {
  label: string;
  button: ReactNode;
  disabled?: boolean;
};

export type SplitButtonProps = Pick<
  ButtonGroupProps,
  'variant' | 'size' | 'color' | 'disabled'
> & {
  options: SplitButtonOption[];
  onSelectedIndexChange?: (index: number) => void;
};

export const SplitButton = (props: SplitButtonProps) => {
  const { options, onSelectedIndexChange, ...buttonGroupProps } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectedOption = options[selectedIndex];

  const handleMenuItemClick = (index: number, close: () => void) => {
    setSelectedIndex(index);
    onSelectedIndexChange?.(index);
    close();
  };

  return (
    <Menu
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      trigger={({ onClick }) => (
        <ButtonGroup {...buttonGroupProps} aria-label="Split button with a nested menu">
          {selectedOption?.button}
          <Button
            size="small"
            aria-label="select action"
            aria-haspopup="menu"
            onClick={onClick}
          >
            <ChevronDownIcon fontSize="small" />
          </Button>
        </ButtonGroup>
      )}
    >
      {({ close }) =>
        options.map((option, index) => (
          <MenuItem
            key={option.label}
            disabled={option.disabled}
            selected={index === selectedIndex}
            onClick={() => handleMenuItemClick(index, close)}
          >
            {option.label}
          </MenuItem>
        ))
      }
    </Menu>
  );
};
